import { render, staticRenderFns } from "./load-more.vue?vue&type=template&id=8acf8112"
import script from "./load-more.vue?vue&type=script&lang=js"
export * from "./load-more.vue?vue&type=script&lang=js"
import style0 from "./load-more.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports